import React, { useMemo, useState } from 'react'
import { Icon, Label, Popup } from 'semantic-ui-react'
import _ from 'lodash'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'

export const PopupDrop = ({ ddOptions, fip, items }) => {

  const { propname, label: caption, value: items_selected, onChange } = fip ?? {}

  const [isOpen, setIsOpen] = useState(false)

  const options = useMemo(() => {
    console.log(ddOptions)
    return ddOptions || _.map(items, item => (
      {
        text: _.startCase(item),
        key: item,
        value: item
      }))
  }, [items, ddOptions])

  const trigger = <div className='field'>
    <label>{caption || 'Prop Name'}</label>
    <div style={{
      width: '100%',
      display: 'flex',
      rowGap: '.5em',
      justifyContent: 'space-between',
      backgroundColor: 'var(--off-black-2)',
      border: '1px solid var(--off-black-4)',
      borderRadius: '4px',
      padding: '.25em',
      alignItems: 'baseline'
    }}>
      <Label
        size='tiny'
        color={_.isEmpty(items_selected) ? 'grey' : 'blue'}
        style={{ margin: '.5em', cursor: 'pointer' }}
      >
        {`${_.size(_.uniq(items_selected))}`}
      </Label>
      <Icon
        name={isOpen ? 'angle down' : 'angle right'}
        style={{ marginLeft: '1em', cursor: 'pointer' }}
        onClick={(e) => {
          setIsOpen(true)
        }}
      />
    </div>
  </div>

  const fnAlt = (item) => {
    const { key } = item
    const _selected = _.includes(items_selected, key)
    return <Icon
      name={_selected ? 'check circle outline' : 'circle outline'}
      color={_selected ? 'green' : 'grey'}
    />
  }

  const toggleItem = (arr, item) =>
    _.includes(arr, item)
      ? _.without(arr, item)
      : [...arr, item]

  const content_ims = () => {
    const hc = (item) => {
      const _selected = toggleItem(items_selected, item.key)
      const data = { propname, value: _selected, options }
      onChange(null, data)
    }
    return <ItemMenuSquares
      menuItems={_.sortBy(options, 'text')}
      imsType={_imsTypes.inline}
      fn_altContent={fnAlt}
      noItemIcon={true}
      onClick={hc}
      style={{ maxHeight: '200px', overflowY: 'auto' }}
    />
  }

  const content_popup = () => <div style={{ display: 'flex', flexDirection: 'column', gap: '.5em', width: '100%' }}>{content_ims()}</div>

  const popup = useMemo(() => {
    return <Popup
      content={content_popup()}
      on='click'
      pinned
      position='bottom left'
      basic
      size='tiny'
      style={{ backgroundColor: 'var(--off-black-4)', color: 'white', borderColor: 'var(--off-black-5)' }}
      trigger={trigger}
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
    // closeOnDocumentClick
    />
  }, [items_selected, ddOptions, isOpen])

  return popup
}
